import css from "./DemoProject.sass?inline"
import { Html } from "@opendaw/lib-dom"
import { createElement } from "@opendaw/lib-jsx"
import { DemoProjectJson } from "@/ui/dashboard/DemoProjectJson"
import { Bytes, Exec, Strings } from "@opendaw/lib-std"

const className = Html.adoptStyleSheet(css, "DemoProject")

type Construct = {
    json: DemoProjectJson
    load: Exec
    extraClassName?: string
    cover?: string
}

export const DemoProject = ({ json, load, extraClassName, cover }: Construct) => {
    const coverUrl = cover ?? (json.hasCover
        ? `/_proxy_api/music/cover.php?id=${json.id}&preview=true`
        : "./empty.svg")
    return (
        <div className={Html.buildClassList(className, extraClassName)} onclick={load}>
            <img src={coverUrl} alt="cover" crossOrigin="anonymous" />
            <div className="meta">
                <div className="title">
                    <span className="name">{json.metadata.name}</span>
                    {Strings.nonEmpty(json.metadata.artist) && <span> by </span>}
                    {Strings.nonEmpty(json.metadata.artist) &&
                        <span className="artist">{json.metadata.artist}</span>}
                    {
                        json.bundleSize > 0 && (
                            <span className="size">({Bytes.toString(json.bundleSize)})</span>
                        )
                    }
                </div>
                <div className="tags">{json.metadata.tags
                    .slice(0, 4)
                    .filter(tag => Strings.nonEmpty(tag))
                    .map(tag => <div>{tag}</div>)}</div>
            </div>
        </div>
    )
}